import React from 'react';
import {
  Alert,
  Backdrop,
  Button,
  Paper,
  Slide,
  Typography,
  Box,
  IconButton,
  Avatar,
} from '@mui/material';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import CloseIcon from '@mui/icons-material/Close';
import useApplication from '../../resources/applications/read';
import { currencyFormat } from '../../constants';
import CheckList from './CheckList';

const emergencyServices = [
  'Towing',
  'Tire Changes',
  'Fluid Delivery',
  'Lock-out Assistance',
  'Jumpstarts',
  'Concierge Services',
];

const discounts = [
  'Rental Cars',
  'Hotels',
  'Travel',
  'Entertainment',
];

// This component needs to handle it's own mounting for the Slide animation.
// However, not all borrowers will have a roadsideLoan so if they don't
// this component can return nothing.

const InstallmentRoadSideAssistance = ({ setValue, showRSA, setShowRSA }) => {
  const { data: application } = useApplication();
  const roadsideLoan = application.attributes.loan_options[0].ancillary_loans[0];
  const regularLoan = application.attributes.loan_options[0].regular_loans[0];

  if (!roadsideLoan) {
    return null;
  }

  return (
    <Backdrop
      open={showRSA}
      sx={{ color: '#fff', zIndex: 9 }}
      transitionDuration={500}
      onClick={() => setShowRSA(false)}
    >
      <Slide direction="up" in={showRSA} mountOnEnter unmountOnExit timeout={500}>
        <Paper
          elevation={0}
          sx={{
            position: 'absolute',
            bottom: 0,
            height: '95%',
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            zIndex: 10,
            p: 2,
            overflowY: 'auto',
            maxWidth: '500px',
            margin: 'auto',
          }}
        >
          <Box sx={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3,
          }}
          >
            <Box display="flex" alignItems="center">
              <Avatar sx={{ bgcolor: 'primary.light', mr: 2 }}>
                <LocalOfferOutlinedIcon color="primary" />
              </Avatar>
              <Box>
                <Typography variant="subtitle1">
                  Special Offer!
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  24/7 Roadside Assistance
                </Typography>
              </Box>
            </Box>
            <IconButton size="small" onClick={() => setShowRSA(false)}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <Typography variant="h4" textAlign="left" sx={{ mb: 1 }}>
            Don&apos;t get stuck on the road!
          </Typography>
          <Typography variant="body2" textAlign="left" sx={{ mb: 2 }}>
            We&apos;ve partnered with Axiom to offer you 24/7 Roadside Assistance.
            Stay protected with towing, tire changes, and more — anytime, anywhere.
          </Typography>

          <CheckList title="Emergency services:" list={emergencyServices} />
          <CheckList title="Plus discounts on:" list={discounts} />

          <Alert icon={false} severity="info" sx={{ mt: 2, mb: 3 }}>
            <Typography variant="body1">
              Add Roadside Assistance for only
              {' '}
              <b>{currencyFormat.format(roadsideLoan.payment - regularLoan.payment)}</b>
              {' '}
              more each month.
            </Typography>
          </Alert>
          <Button
            fullWidth
            onClick={() => {
              setValue('loanPackageId', roadsideLoan.id);
              setShowRSA(false);
            }}
            sx={{ mb: 2 }}
          >
            Add Roadside Assistance
          </Button>
          <Button
            fullWidth
            variant="text"
            onClick={() => {
              setValue('loanPackageId', regularLoan.id);
              setShowRSA(false);
            }}
          >
            No Thank You
          </Button>
        </Paper>
      </Slide>
    </Backdrop>
  );
};

export default InstallmentRoadSideAssistance;
